import { ColorTypes, Text, TypoFontFace, Link } from '@afterpaytouch/core'
import React, { AnchorHTMLAttributes, FunctionComponent, PropsWithChildren, SyntheticEvent } from 'react'

export interface TermLinkProps {
  target?: AnchorHTMLAttributes<HTMLAnchorElement>['target']
  href: AnchorHTMLAttributes<HTMLAnchorElement>['href']
  onClick?: (e: SyntheticEvent) => void
  testNameSpace?: string
  color?: ColorTypes
  fontFace?: TypoFontFace
}
export const TermLink: FunctionComponent<PropsWithChildren<TermLinkProps>> = ({
  target = '_blank',
  href = '',
  onClick = () => {},
  testNameSpace = '',
  children,
  color,
  fontFace,
  ...otherProps
}) => (
  <Link
    onClick={onClick}
    href={href}
    target={target}
    rel='noopener noreferrer'
    kind='Underline'
    {...(testNameSpace.length > 0 && { 'data-testid': `${testNameSpace}-term-link` })}
    {...otherProps}
  >
    <Text bold underline renderAs='span' color={color} fontFace={fontFace}>
      {children}
    </Text>
  </Link>
)
